import {mapGetters} from 'vuex'

export const eventMixin = {
    computed: {
        ...mapGetters([
            'account',
            'getAgents',
        ]),
    },
    methods: {
        cutOffChannelValidation: function (salesChannel, specificEvent) {
            let event
            if(specificEvent){
                event = specificEvent
            } else {
                event = typeof this.event != "undefined"? this.event : this.reservation.event
            }
            // will return false if channel is hard cutoff
            // Soft Cutoff will return true
            // no cutoff will return true
            if(typeof event.hasCutOff == "undefined" || event.hasCutOff != true){
                return true
            } else {
                // are we inside the cutoff time window? AND the cutoff aplies to "my team"
                if(moment().isAfter(moment(event.eventCutOffStart)) && event.cutOffChannelsMain.some(channel => channel.channelType == salesChannel.channelType)){

                    // cutoff is enabled, is it softCutOff?
                    if(event.softCutOff){
                        return true
                    } else {
                        // is hard cutoff
                        return false
                    }

                } else {
                    return true
                }
            }

        },
        salesChannelOpenValidation: function (salesChannel, specificEvent) {
            // checks if the salesChannel can sell
            let event
            if(specificEvent){
                event = specificEvent
            } else {
                event = typeof this.event != "undefined"? this.event : this.reservation.event
            }
            if(!event.channelCommissions){
                return false
            }else{
                let filtered = !salesChannel.id ? event.channelCommissions.filter(channel => {
                  return channel.channelType == salesChannel.channelType
                })
                : event.channelCommissions.filter(channel => {
                  return channel.channelId == salesChannel.id
                })
                return (filtered.length > 0)? filtered[0].isActive : false
            }
        },
        executeValidations: function (validationObject) {
            let output = true
            let reasonsArray = []
            for (var currentValidation of validationObject.validations) {
                if(currentValidation.test() == false){
                    output = false
                    reasonsArray.push(currentValidation.errorMessage)
                }
            }
            return {
                result:output,
                reasons: reasonsArray
            }
        },
        isEventInsideCutoff: function (event) {
            if(typeof event.hasCutOff != "undefined" && event.hasCutOff == true && moment().isAfter(moment(event.eventCutOffStart))){
                return true
            } else {
                return false
            }

        },
        canISellThisEvent: function (event) {
            var myTeamValidations = {
                validations:[
                    {
                        name:"salesChannel",
                        test: () => {
                            return this.salesChannelOpenValidation(this.account.salesChannel, event)
                        },
                        errorMessage: "Sales channel closed"
                    },
                    {
                        name: "cutoff",
                        test: () => {
                            return this.cutOffChannelValidation(this.account.salesChannel, event)
                        },
                        errorMessage: "Closed by cutoff"
                    },
                ],

            }

            let validationProcessed = this.executeValidations(myTeamValidations)


            return {
                allowed: validationProcessed.result,
                reasons: validationProcessed.reasons
            }
        },
        canAgentSellThisEvent: function (event) {

            var agentsValidations = {
                validations:[
                    {
                        name:"salesChannel",
                        test: () => {
                            return this.salesChannelOpenValidation({channelType:50})
                        },
                        errorMessage: "Sales channel closed"
                    },
                    {
                        name: "cutoff",
                        test: () => {
                            return this.cutOffChannelValidation({channelType:50})
                        },
                        errorMessage: "Closed by cutoff"
                    },
                ],

            }

            let validationProcessed = this.executeValidations(agentsValidations)


            return {
                allowed: validationProcessed.result,
                reasons: validationProcessed.reasons
            }
        },
        canAgentCustomSellThisEvent: function (event) {
            if(!event.salesPermissionsAgentsList || event.salesPermissionsAgentsList.length == 0){
                return false
            }

            return event.salesPermissionsAgentsList.length > 0
        },
        canWidgetSellThisEvent: function (event) {
            var agentsValidations = {
                validations:[
                    {
                        name:"salesChannel",
                        test: () => {
                            return this.salesChannelOpenValidation({channelType:101})
                        },
                        errorMessage: "Sales channel closed"
                    },
                    {
                        name: "cutoff",
                        test: () => {
                            return this.cutOffChannelValidation({channelType:101})
                        },
                        errorMessage: "Closed by cutoff"
                    },
                ],

            }

            let validationProcessed = this.executeValidations(agentsValidations)


            return {
                allowed: validationProcessed.result,
                reasons: validationProcessed.reasons
            }
        },
        eventHasCustomAgents: function (event) {
            return event.salesPermissionsAgentsList && event.salesPermissionsAgentsList.length > 0
        },
        eventPossibleAgentsList: function (event) {
            if(!this.canAgentSellThisEvent(event).allowed){
                // return [] // if agents channel closed the picker shows no agents
                return this.customAgentsArrayMixedWithLabel([]) // if agents channel closed the picker shows all agents but with closed flag
            } else {
                if(this.eventHasCustomAgents(event)){
                    // this allows to show only the agents that are selected (disabled for now, all agents are shown)
                    return this.customAgentsArrayMixedWithLabel(event.salesPermissionsAgentsList)
                    // return this.getAgents
                } else {
                    return this.getAgents
                }
            }
        },
        customAgentsArrayMixedWithLabel: function(customAgentsArray){
            let allAgents = JSON.parse(JSON.stringify(this.getAgents))

            allAgents.map(originalAgent => {
                let addLabel = true
                if(customAgentsArray)
                customAgentsArray.map(allowedAgent => {
                    if(originalAgent.id == allowedAgent.id){
                        addLabel = false
                    }

                })

                if(addLabel){
                    originalAgent.channelClosed = true
                }
            })

            return allAgents
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/event.js